import { generateRequest } from './index';
import { toQueryString } from '../../lib/utils/querystring';

export const Action = {
  Badges: {
    BadgeAdsPending: 'BadgeAds_PENDING',
    BadgeAdsCompleted: 'BadgeAds_FULFILLED',
    BadgeAdsFailed: 'BadgeAds_FAILED',
  },
};

export const fetchBadgeAds = badgeIds => generateRequest({
  endpoint: `/assets-v2/api/badges/ads?${toQueryString({ badgeIds })}`,
  types: [
    Action.Badges.BadgeAdsPending,
    Action.Badges.BadgeAdsCompleted,
    Action.Badges.BadgeAdsFailed,
  ],
});
